import { SaveReportNameConfigContentForm } from './SaveReportNameConfigContentForm';

export default SaveReportNameConfigContentForm;
